import { Slot, Slottable } from '@radix-ui/react-slot';
import { clsx } from 'clsx';
import { ComponentPropsWithRef } from 'react';
import { linkButton, linkButtonSize } from './link-button.css';

type LinkButtonProps = {
  size?: 'small' | 'medium' | 'large';
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
  asChild?: boolean;
} & ComponentPropsWithRef<'button'>;

export const LinkButton = function LinkButtonComponent({
  ref,
  size = 'medium',
  className,
  children,
  type = 'button',
  disabled = false,
  startIcon,
  endIcon,
  asChild,
  ...rest
}: LinkButtonProps) {
  const Component = asChild ? Slot : 'button';

  return (
    <Component
      ref={ref}
      type={type}
      className={clsx(linkButton, linkButtonSize[size], className)}
      disabled={disabled}
      {...rest}
    >
      {startIcon}
      <Slottable>{children}</Slottable>
      {endIcon}
    </Component>
  );
};
